import {
  PermissionValues as Permissions,
  useCurrentAccount,
  useCurrentWorkspace,
} from '@gripp/shared-logic';
import { AddButton } from '../../shared/components/addButton/addButton';
import { useGroupsCreation } from './groupsCreationContext';

export const GroupsToolbar = () => {
  const currentWorkspace = useCurrentWorkspace();
  const groupsCreation = useGroupsCreation();
  const { account } = useCurrentAccount();
  const canCreate = !!(account?.hasPermission(Permissions.workspace.create));

  return (
    currentWorkspace &&
    groupsCreation &&
    canCreate && <AddButton onPress={groupsCreation.openNew} />
  );
};
